import React, { useState, useCallback } from "react";
import { formStyles as s, downloadBtnStyle, DownloadIcon } from "./formStyles";
import SignaturePad from "../components/SignaturePad";


const PRODUCTS = [
  { name: "Polo Shirt Mid Blue Team Member", cost: 5.0 },
  { name: "Polo Shirt Dark Blue SNL Management", cost: 5.0 },
  { name: "SNL Shirt SNL Management", cost: 15.0 },
  { name: "SNL All Weather Shell Jacket", cost: 25.0 },
  { name: "PPE: Hi Vis Vest", cost: 5.0 },
  { name: "PPE: Eye Protection", cost: 5.0 },
  { name: "PPE: Hearing Protection", cost: 5.0 },
  { name: "PPE: Leather Outrigger Gloves", cost: 5.0 },
  { name: "PPE: 3/4 Gloves", cost: 7.0 },
];

const VARIANTS = {
  male: {
    title: "Male Uniform Issue Order Form",
    sizes: ["Select", "S", "M", "L", "XL", "2XL", "3XL"],
    dropdownPrefix: "Dropdown",
    pdfDefault: "/static/pdffilters/SNL-Uniform-Male-Form.pdf",
    filePrefix: "SNL-Male-Uniform",
  },
  female: {
    title: "Female Uniform Issue Order Form",
    sizes: ["Select", "S", "M", "L", "10", "12", "14", "16"],
    dropdownPrefix: "Dropdown",
    dropdownSuffix: "F",
    pdfDefault: "/static/pdffilters/SNL-Uniform-Female-Form.pdf",
    filePrefix: "SNL-Female-Uniform",
  },
};

const UniformForm = ({ variant = "male", pdfUrl }) => {
  const config = VARIANTS[variant] || VARIANTS.male;
  const url = pdfUrl || config.pdfDefault;

  const [info, setInfo] = useState({
    teamMemberName: "",
    issuedBy: "",
    siteLocation: "",
    position: "",
  });
  const [rows, setRows] = useState(PRODUCTS.map(() => ({ size: "Select", qty: "" })));
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState(null);

  const updateInfo = (field, value) => setInfo((p) => ({ ...p, [field]: value }));
  const updateRow = (idx, field, value) =>
    setRows((p) => p.map((r, i) => (i === idx ? { ...r, [field]: value } : r)));

  const getRowTotal = (idx) => ((parseInt(rows[idx].qty) || 0) * PRODUCTS[idx].cost).toFixed(2);
  const getTotalQty = () => rows.reduce((sum, r) => sum + (parseInt(r.qty) || 0), 0);
  const getTotalCost = () =>
    rows.reduce((sum, r, i) => sum + (parseInt(r.qty) || 0) * PRODUCTS[i].cost, 0).toFixed(2);
const [signatures, setSignatures] = useState({
    manager: null,
    member: null,
    
  });
const handleSigSave = useCallback((key) => (dataUrl) => {
    setSignatures((p) => ({ ...p, [key]: dataUrl }));
  }, []);

  const handleSigClear = useCallback((key) => () => {
    setSignatures((p) => ({ ...p, [key]: null }));
  }, []);
  const isValid = info.teamMemberName.trim() && info.issuedBy.trim() && info.siteLocation.trim() && rows.some((r) => parseInt(r.qty) > 0);

  const handleDownload = async () => {
    setDownloading(true);
    setError(null);
    try {
      const { PDFDocument, PDFName } = await import("pdf-lib");
      const pdfBytes = await fetch(url).then((res) => {
        if (!res.ok) throw new Error("Could not load PDF template");
        return res.arrayBuffer();
      });
      const pdfDoc = await PDFDocument.load(pdfBytes);
      
      const form = pdfDoc.getForm();

      form.getTextField("Team Member Name").setText(info.teamMemberName);
      form.getTextField("Issued By").setText(info.issuedBy);
      form.getTextField("Site Location").setText(info.siteLocation);
      form.getTextField("Position").setText(info.position);

      rows.forEach((row, i) => {
        const num = i + 1;
        const qty = parseInt(row.qty) || 0;
        const suffix = config.dropdownSuffix || "";
        const ddName = `${config.dropdownPrefix}${num}${suffix}`;

        if (row.size !== "Select") {
          try { form.getDropdown(ddName).select(row.size); } catch (e) { /* skip */ }
        }
        form.getTextField(`Qty${num}`).setText(qty > 0 ? String(qty) : "");
        form.getTextField(`Total${num}`).setText((qty * PRODUCTS[i].cost).toFixed(2));
      });

      form.getTextField("TotalQty").setText(String(getTotalQty()));
      form.getTextField("TotalCost").setText(getTotalCost());


      const embedSigOnPage = async (sigDataUrl, fieldName) => {
      if (!sigDataUrl) return;
      try {
        const base64 = sigDataUrl.split(",")[1];
        const sigBytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
        const sigImage = await pdfDoc.embedPng(sigBytes);

        const sigField = form.getTextField(fieldName);
        const widgets = sigField.acroField.getWidgets();
        if (widgets.length === 0) return;

        const widget = widgets[0];
        const rect = widget.getRectangle();

        const pages = pdfDoc.getPages();
        let targetPage = null;

        for (const page of pages) {
          const annotsRef = page.node.get(PDFName.of("Annots"));
          if (!annotsRef) continue;
          const annots = page.node.context.lookup(annotsRef);
          if (!annots) continue;
          const arr = annots.asArray ? annots.asArray() : [];
          for (const ref of arr) {
            if (ref === widget.ref) { targetPage = page; break; }
          }
          if (targetPage) break;
        }

        if (!targetPage) {
          for (const page of pages) {
            const annotsRef = page.node.get(PDFName.of("Annots"));
            if (!annotsRef) continue;
            const annots = page.node.context.lookup(annotsRef);
            if (!annots) continue;
            const arr = annots.asArray ? annots.asArray() : [];
            for (const ref of arr) {
              const resolved = page.node.context.lookup(ref);
              if (resolved === widget.dict) { targetPage = page; break; }
            }
            if (targetPage) break;
          }
        }

        if (!targetPage) targetPage = pages[pages.length - 1];

        form.removeField(sigField);

        const aspectRatio = sigImage.width / sigImage.height;
        let drawWidth = rect.width;
        let drawHeight = drawWidth / aspectRatio;
        if (drawHeight > rect.height) {
          drawHeight = rect.height;
          drawWidth = drawHeight * aspectRatio;
        }

        const x = rect.x + (rect.width - drawWidth) / 2;
        const y = rect.y + (rect.height - drawHeight) / 2;

        targetPage.drawImage(sigImage, { x, y, width: drawWidth, height: drawHeight });
      } catch (e) {
        console.error(`Sig embed failed for ${fieldName}:`, e);
        try { form.getTextField(fieldName).setText("[Signed]"); } catch (_) {}
      }
    };

    
    await embedSigOnPage(signatures.manager, "Supervisor Signature");
    await embedSigOnPage(signatures.member, "Member Signature");
    

      pdfDoc.setTitle(`Uniform Issue Order Form - ${form.memberName}`);
      form.flatten();

      const filled = await pdfDoc.save();
      const blob = new Blob([filled], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${config.filePrefix}-${info.teamMemberName || "Form"}.pdf`;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (err) {
      console.error("PDF fill error:", err);
      setError(err.message || "Failed to generate PDF");
    } finally {
      setDownloading(false);
    }
  };

  const handleReset = () => {
    setInfo({ teamMemberName: "", issuedBy: "", siteLocation: "", position: "" });
    setRows(PRODUCTS.map(() => ({ size: "Select", qty: "" })));
    setError(null);
  };

  return (
    <div style={s.wrapper}>
      <style>{s.spinKeyframes}</style>

      <h2 style={s.title}>{config.title}</h2>
      <p style={s.subtitle}>Fill out the form below and download the completed PDF</p>

      {/* Team Info */}
      <div style={s.section}>
        <div style={s.sectionLabel}>Team Member Details</div>
        <div style={s.fieldGrid2}>
          <div style={s.fieldGroup}>
            <label style={s.label}>Team Member Name *</label>
            <input style={s.input} value={info.teamMemberName} onChange={(e) => updateInfo("teamMemberName", e.target.value)} placeholder="Full name" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Issued By *</label>
            <input style={s.input} value={info.issuedBy} onChange={(e) => updateInfo("issuedBy", e.target.value)} placeholder="Issuer name" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Site Location *</label>
            <input style={s.input} value={info.siteLocation} onChange={(e) => updateInfo("siteLocation", e.target.value)} placeholder="Location" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Position</label>
            <input style={s.input} value={info.position} onChange={(e) => updateInfo("position", e.target.value)} placeholder="Job title" />
          </div>
        </div>
      </div>

      {/* Product Table */}
      <div style={s.section}>
        <div style={s.sectionLabel}>Uniform Items</div>
        <div style={{ overflowX: "auto" }}>
          <table style={s.table}>
            <thead>
              <tr>
                <th style={s.th}>Product</th>
                <th style={s.th}>Size</th>
                <th style={s.thRight}>Cost</th>
                <th style={s.th}>Qty</th>
                <th style={s.thRight}>Total</th>
              </tr>
            </thead>
            <tbody>
              {PRODUCTS.map((product, idx) => (
                <tr key={idx}>
                  <td style={s.tdFirst}><span style={s.productName}>{product.name}</span></td>
                  <td style={s.td}>
                    <select style={s.selectSmall} value={rows[idx].size} onChange={(e) => updateRow(idx, "size", e.target.value)}>
                      {config.sizes.map((opt) => (<option key={opt} value={opt} style={s.optionStyle}>{opt}</option>))}
                    </select>
                  </td>
                  <td style={{ ...s.td, ...s.cost }}>${product.cost.toFixed(2)}</td>
                  <td style={s.td}>
                    <input style={s.qtyInput} type="number" min="0" max="99" value={rows[idx].qty} onChange={(e) => updateRow(idx, "qty", e.target.value)} placeholder="0" />
                  </td>
                  <td style={s.tdLast}><span style={s.rowTotal}>${getRowTotal(idx)}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div style={s.totalRow}>
          <span style={s.totalLabel}>Total Qty: {getTotalQty()}</span>
          <span style={s.totalValue}>${getTotalCost()}</span>
        </div>
      </div>

      <p style={s.disclaimer}>
        I understand that I have been issued the above uniforms to wear while on SNL Sites.
        I will follow the grooming and appearance standards and properly maintain them according
        to the provided care guidelines. Upon termination from SNL Commercial Property Services
        Pty Ltd, the above uniforms must be cleaned and returned prior to the final payment being
        issued. The bond will be deducted from my first payment and held.
      </p>


      <div style={s.section}>
        <p style={s.pageLabel}>Signatures</p>
        <div style={s.signatureGrid}>
          <div style={s.signatureBlock}>
            <span style={{
                ...s.signatureLabel,
                color: signatures.manager ? "rgba(255,255,255,0.6)" : "rgba(239,68,68,0.7)"
              }}>
                Supervisor Signature
              </span>
            <SignaturePad label="" width={300} height={120} onSave={handleSigSave("manager")} onClear={handleSigClear("manager")} />
            
          </div>
          <div style={s.signatureBlock}>
            <span style={{
                ...s.signatureLabel,
                color: signatures.member ? "rgba(255,255,255,0.6)" : "rgba(239,68,68,0.7)"
              }}>
                Team Member Signature
              </span>
            <SignaturePad label="" width={300} height={120} onSave={handleSigSave("member")} onClear={handleSigClear("member")} />
            
          </div>
        </div>
      </div>

      <div style={s.btnRow}>
        <button style={downloadBtnStyle(isValid)} onClick={handleDownload} disabled={!isValid || downloading}>
          {downloading ? (<><span style={s.spinner} /> Generating PDF...</>) : (<><DownloadIcon /> Download Filled PDF</>)}
        </button>
        <button style={s.resetBtn} onClick={handleReset}>Reset</button>
      </div>
      {error && <div style={s.error}>{error}</div>}
    </div>
  );
};

export default UniformForm;